import { collection, QueryDocumentSnapshot } from "firebase/firestore";

import { db } from "~/integrations/firebase/firestore";
import { OnixImportPipelineReporting } from "reedy-data/models";

export interface PipelineReportWithId extends OnixImportPipelineReporting {
  id: string;
  typesenseIsbns?: string[]; // legacy field for compatability with existing reports
}

type PipelineImportReportFromFirebase = OnixImportPipelineReporting;

const pipelineReportConverter = {
  toFirestore: (report: PipelineReportWithId) => {
    // biome-ignore lint/correctness/noUnusedVariables: drops id before the document is written to Firestore
    const { id, ...rest } = report;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot<PipelineImportReportFromFirebase>,
  ): PipelineReportWithId {
    const data = snapshot.data();

    return {
      ...data,
      id: snapshot.id,
    };
  },
};

export const getPipelineReportCollection = () =>
  collection(db, "pipelineReporting").withConverter(pipelineReportConverter);
